import * as React from 'react'

interface Props {
    title: string
    disabled?: boolean
    onClick:() => void
}

export const ContinueButton : React.FC<Props> = ({
    title, onClick, disabled
}) => {
    return (
        <button
            onClick={onClick}
            className="btn btn-lg btn-block btn-form"
            type="button"
            disabled={disabled}>
            {title}
        </button>

    )
}

ContinueButton.defaultProps = {
    disabled: false
}
